import { StateCreator } from 'zustand';
import i18n from 'i18next';

import { CombinedSlices } from '.';
import { Store } from '../models';

export interface IndexSlice {
  store?: Store | null; // Selected Store
  language: string;
  setLanguage: (language?: string | null) => void;
}

export const createIndexSlice: StateCreator<
  CombinedSlices,
  [],
  [],
  IndexSlice
> = (set) => ({
  language: i18n.language,
  setLanguage: (language?: string | null) => {
    const l = language ? language : i18n.language;

    i18n.changeLanguage(l);

    set(() => {
      return ({
        language: l
      });
    })
  }
});